import React from 'react';
import {
	FormattedMessage,
	defineMessages,
} from 'react-intl';

import {
	SECTION_ACCESS_CONTROL,
	SECTION_ADVANCED_ANALYSIS,
	SECTION_ADVANCED_FEATURES,
	SECTION_COLLABORATION,
	SECTION_CORE_FEATURES,
	SECTION_INTEGRATIONS,
	SECTION_MONITORING_SETTINGS,
	SECTION_SERVICES,
} from '~/model/benefits';



const messages = defineMessages({
	[SECTION_ACCESS_CONTROL]: {
		id: 'ui.planBenefits.section.accessControl.heading',
	},
	[SECTION_ADVANCED_ANALYSIS]: {
		id: 'ui.planBenefits.section.advancedAnalysis.heading',
	},
	[SECTION_ADVANCED_FEATURES]: {
		id: 'ui.planBenefits.section.advancedFeatures.heading',
	},
	[SECTION_COLLABORATION]: {
		id: 'ui.planBenefits.section.collaboration.heading',
	},
	[SECTION_CORE_FEATURES]: {
		id: 'ui.planBenefits.section.coreFeatures.heading',
	},
	[SECTION_INTEGRATIONS]: {
		id: 'ui.planBenefits.section.integrations.heading',
	},
	[SECTION_MONITORING_SETTINGS]: {
		id: 'ui.planBenefits.section.monitoringSettings.heading',
	},
	[SECTION_SERVICES]: {
		id: 'ui.planBenefits.section.services.heading',
	},
});



const BenefitSectionName = (props) => {
	const {
		section,
	} = props;

	return (
		<FormattedMessage {...messages[section]} />
	);
};



export default BenefitSectionName;
